import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import "bootstrap/dist/css/bootstrap.min.css";
import "./card-style.css";

export default function ActionAreaCard(props) {
  return (
    <>
    {(props.content)?props.content:
    <Card sx={{ maxWidth: 800 }} variant="outlined">
      <CardActionArea onClick={props.onClick}>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div" color='#5a5757'>
            {props.title}
          </Typography>
          {(props.description) && 
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {props.description}
          </Typography>}
		  {(props.content)?props.content:null}
        </CardContent>
      </CardActionArea>
    </Card>
    }
    </>
  );
}